/* =====================================================================
   BZT Tool-Core — gemeinsame Bausteine der CNC-Rechner ("Cockpit"-Layout)
   Angelegt 23.09.2026 (Relaunch-Plan reports/tools-relaunch-plan-2026-09-23.md).
   Vanilla-JS, keine Abhängigkeiten. Stellt window.BZTTool bereit:

     gauge(host)                 Drehzahl-Tacho (Halbkreis) mit Empfehlungsband,
                                 Grenzmarke und Zeiger. .update({...})
     materialCards(select, host) Radio-Karten statt Dropdown; das <select>
                                 bleibt Quelle der Wahrheit (Deep-Links, Logik).
     steppers(root)              −/+ an input[data-stepper], respektiert
                                 step/min/max und löst 'input' aus.
     resultBar(root, panel)      Mobile Ergebnisleiste: sichtbar, solange man
                                 im Rechner ist, das Ergebnis aber außer Sicht.
   ===================================================================== */
(function () {
  'use strict';
  if (window.BZTTool) return;

  var NS = 'http://www.w3.org/2000/svg';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var LOCALE = isEn ? 'en-GB' : 'de-DE';

  function fmt(n, dec) {
    return Number(n).toLocaleString(LOCALE, { minimumFractionDigits: dec || 0, maximumFractionDigits: dec || 0 });
  }
  function short(n) {
    if (n >= 1000) return fmt(n / 1000, n % 1000 ? 1 : 0) + 'k';
    return fmt(n);
  }
  function el(tag, attrs, parent) {
    var e = document.createElementNS(NS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }

  /* ---------- Tacho ---------------------------------------------------
     Halbkreis von links (0) nach rechts (max). Band und Grenzzone laufen
     über stroke-dasharray auf pathLength=100, damit sie per CSS gleiten. */
  var SCALES = [500, 1000, 2000, 3000, 5000, 8000, 10000, 12000, 15000, 20000, 24000, 30000, 40000, 60000, 80000];
  function niceMax(v) {
    for (var i = 0; i < SCALES.length; i++) if (SCALES[i] >= v) return SCALES[i];
    return Math.ceil(v / 10000) * 10000;
  }
  function gauge(host) {
    var cx = 120, cy = 118, r = 96;
    var svg = el('svg', { viewBox: '0 0 240 142', class: 'bzt-gauge__svg', 'aria-hidden': 'true', focusable: 'false' }, host);
    var arcD = 'M ' + (cx - r) + ' ' + cy + ' A ' + r + ' ' + r + ' 0 0 1 ' + (cx + r) + ' ' + cy;
    el('path', { d: arcD, class: 'bzt-gauge__track', pathLength: 100 }, svg);
    var limitArc = el('path', { d: arcD, class: 'bzt-gauge__limitzone', pathLength: 100 }, svg);
    var band = el('path', { d: arcD, class: 'bzt-gauge__band', pathLength: 100 }, svg);
    var ticks = el('g', { class: 'bzt-gauge__ticks' }, svg);
    var limitMark = el('g', { class: 'bzt-gauge__limit' }, svg);
    el('line', { x1: cx, y1: cy - r - 11, x2: cx, y2: cy - r + 11 }, limitMark);
    var needle = el('g', { class: 'bzt-gauge__needle' }, svg);
    el('line', { x1: cx, y1: cy, x2: cx - r + 18, y2: cy }, needle);
    el('circle', { cx: cx, cy: cy, r: 6.5 }, needle);
    var caption = document.createElement('div');
    caption.className = 'bzt-gauge__legend';
    host.appendChild(caption);

    function pct(v, max) { return Math.max(0, Math.min(100, (v / max) * 100)); }
    function drawTicks(max) {
      while (ticks.firstChild) ticks.removeChild(ticks.firstChild);
      [0, 0.25, 0.5, 0.75, 1].forEach(function (f) {
        var a = Math.PI * (1 - f);
        var x1 = cx + Math.cos(a) * (r - 13), y1 = cy - Math.sin(a) * (r - 13);
        var x2 = cx + Math.cos(a) * (r - 6), y2 = cy - Math.sin(a) * (r - 6);
        el('line', { x1: x1, y1: y1, x2: x2, y2: y2 }, ticks);
        var tx = cx + Math.cos(a) * (r - 27), ty = cy - Math.sin(a) * (r - 27) + 4;
        var t = el('text', { x: tx, y: ty, 'text-anchor': f === 0 ? 'start' : (f === 1 ? 'end' : 'middle') }, ticks);
        t.textContent = short(max * f);
      });
    }
    var lastMax = null;
    return {
      /* o: { lo, hi, limit (optional), limitLabel, bandLabel } */
      update: function (o) {
        var lo = Math.max(0, o.lo || 0), hi = Math.max(lo, o.hi || 0);
        var max = niceMax(Math.max(hi * 1.12, o.limit ? o.limit * 1.08 : 0, 500));
        if (max !== lastMax) { drawTicks(max); lastMax = max; }
        var a = pct(lo, max), b = pct(hi, max);
        band.style.strokeDasharray = Math.max(0.8, b - a) + ' 200';
        band.style.strokeDashoffset = String(-a);
        var mid = (lo + hi) / 2;
        needle.style.transform = 'rotate(' + (pct(mid, max) * 1.8) + 'deg)';
        if (o.limit && o.limit < max) {
          var l = pct(o.limit, max);
          limitArc.style.strokeDasharray = (100 - l) + ' 200';
          limitArc.style.strokeDashoffset = String(-l);
          limitArc.style.opacity = '1';
          limitMark.style.opacity = '1';
          limitMark.style.transform = 'rotate(' + (l * 1.8 - 90) + 'deg)';
        } else {
          limitArc.style.opacity = '0';
          limitMark.style.opacity = '0';
        }
        caption.innerHTML =
          '<span class="bzt-gauge__key bzt-gauge__key--band">' + (o.bandLabel || '') + '</span>' +
          (o.limit ? '<span class="bzt-gauge__key bzt-gauge__key--limit">' + (o.limitLabel || '') + '</span>' : '');
        host.classList.toggle('bzt-gauge--over', !!(o.limit && hi > o.limit));
      }
    };
  }
  gauge.cx = 120; gauge.cy = 118;

  /* ---------- Materialkarten ----------------------------------------- */
  function materialCards(select, host, meta) {
    var name = 'bztmat-' + Math.random().toString(36).slice(2, 8);
    host.setAttribute('role', 'radiogroup');
    var inputs = [];
    Array.prototype.forEach.call(select.options, function (opt) {
      if (!opt.value) return;
      var label = document.createElement('label');
      label.className = 'bzt-mat';
      var input = document.createElement('input');
      input.type = 'radio'; input.name = name; input.value = opt.value;
      input.className = 'bzt-mat__radio';
      if (select.value === opt.value) input.checked = true;
      var t = document.createElement('span');
      t.className = 'bzt-mat__name';
      t.textContent = opt.textContent.replace(/\s*\(.*\)\s*$/, '');
      var sub = document.createElement('span');
      sub.className = 'bzt-mat__meta';
      var m = opt.textContent.match(/\((.*)\)\s*$/);
      sub.textContent = meta ? meta(opt.value) : (m ? m[1] : '');
      label.appendChild(input); label.appendChild(t);
      if (sub.textContent) label.appendChild(sub);
      host.appendChild(label);
      inputs.push(input);
      input.addEventListener('change', function () {
        if (!input.checked) return;
        select.value = input.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    select.addEventListener('change', function () {
      inputs.forEach(function (i) { i.checked = i.value === select.value; });
    });
  }

  /* ---------- Stepper ------------------------------------------------ */
  var ICON_MINUS = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 10h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 5v10M5 10h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  function steppers(root) {
    root.querySelectorAll('input[data-stepper]').forEach(function (input) {
      if (input.parentNode.classList.contains('bzt-num')) {
        var wrap = input.parentNode;
      } else {
        wrap = document.createElement('span');
        wrap.className = 'bzt-num';
        input.parentNode.insertBefore(wrap, input);
        wrap.appendChild(input);
      }
      var lbl = input.getAttribute('aria-label') || '';
      /* Wortlaut wie im Warenkorb (DE „Menge verringern“, EN „Decrease quantity“): Sprachqualität W2 g7 */
      var lblLc = lbl.replace(/^[A-Z](?=[a-z])/, function (c) { return c.toLowerCase(); });
      var ariaDown = isEn ? ('Decrease ' + lblLc).trim() : (lbl ? lbl + ' verringern' : 'Verringern');
      var ariaUp = isEn ? ('Increase ' + lblLc).trim() : (lbl ? lbl + ' erhöhen' : 'Erhöhen');
      function mk(dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bzt-num__btn bzt-num__btn--' + (dir < 0 ? 'down' : 'up');
        b.innerHTML = dir < 0 ? ICON_MINUS : ICON_PLUS;
        b.setAttribute('aria-label', dir < 0 ? ariaDown : ariaUp);
        b.addEventListener('click', function () {
          var step = parseFloat(input.getAttribute('data-stepper')) || parseFloat(input.step) || 1;
          var v = parseFloat(String(input.value).replace(',', '.'));
          if (!isFinite(v)) v = parseFloat(input.min) || 0;
          v = Math.round((v + dir * step) / step) * step;
          var mn = parseFloat(input.min), mx = parseFloat(input.max);
          if (isFinite(mn) && v < mn) v = mn;
          if (isFinite(mx) && v > mx) v = mx;
          input.value = String(parseFloat(v.toFixed(3)));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          sync();
        });
        return b;
      }
      var down = mk(-1), up = mk(1);
      wrap.insertBefore(down, input);
      wrap.appendChild(up);
      var unit = input.getAttribute('data-unit');
      if (unit && !wrap.querySelector('.bzt-num__unit')) {
        var u = document.createElement('span');
        u.className = 'bzt-num__unit'; u.setAttribute('aria-hidden', 'true'); u.textContent = unit;
        wrap.insertBefore(u, up);
      }
      function sync() {
        var v = parseFloat(String(input.value).replace(',', '.'));
        down.disabled = isFinite(v) && isFinite(parseFloat(input.min)) && v <= parseFloat(input.min);
        up.disabled = isFinite(v) && isFinite(parseFloat(input.max)) && v >= parseFloat(input.max);
      }
      input.addEventListener('input', sync);
      sync();
    });
  }

  /* ---------- Mobile Ergebnisleiste -----------------------------------
     Nur im einspaltigen Layout (Panel unter den Eingaben). Sichtbar, wenn
     der Rechner im Bild ist, das Ergebnis-Panel aber nicht. */
  function resultBar(root, panel, labelText) {
    // Ohne IntersectionObserver keine Leiste, aber dieselbe Schnittstelle (sonst Absturz beim label()-Aufruf)
    if (!('IntersectionObserver' in window)) return { set: function () {}, label: function () {} };
    var bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'bzt-resultbar';
    bar.setAttribute('aria-hidden', 'true');
    bar.tabIndex = -1;
    bar.innerHTML =
      '<span class="bzt-resultbar__k"></span>' +
      '<span class="bzt-resultbar__v"></span>' +
      '<span class="bzt-resultbar__go">' + (isEn ? 'Details' : 'Details') +
      '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M6 8l4 4 4-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    bar.querySelector('.bzt-resultbar__k').textContent = labelText || '';
    document.body.appendChild(bar);
    var mq = window.matchMedia('(max-width: 899px)');
    var rootIn = false, panelIn = true;
    function render() {
      var on = mq.matches && rootIn && !panelIn;
      bar.classList.toggle('bzt-resultbar--on', on);
      document.body.classList.toggle('bzt-resultbar-on', on);
    }
    new IntersectionObserver(function (e) { rootIn = e[0].isIntersecting; render(); }, { threshold: 0 }).observe(root);
    new IntersectionObserver(function (e) { panelIn = e[0].isIntersecting; render(); }, { threshold: 0.35 }).observe(panel);
    if (mq.addEventListener) mq.addEventListener('change', render);
    bar.addEventListener('click', function () {
      panel.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
    return {
      set: function (v) { bar.querySelector('.bzt-resultbar__v').innerHTML = v; },
      label: function (t) { bar.querySelector('.bzt-resultbar__k').textContent = t; }
    };
  }

  /* ---------- Shop-Empfehlung platzieren ------------------------------
     Die Empfehlung kommt aus Liquid (Collection, Bilder), das Ergebnis per
     innerHTML aus JS. Nach jedem Rendern wird die Karte direkt vor die
     Anfrage-Zeile gesetzt, also unmittelbar unter die Werte. */
  function attachRec(panel, out) {
    var rec = panel && panel.querySelector('.bzt-rec');
    return function () {
      if (!rec) return;
      var anchor = out.querySelector('.bzt-calc__cta');
      if (anchor) anchor.parentNode.insertBefore(rec, anchor);
      else out.appendChild(rec);
    };
  }

  window.BZTTool = { attachRec: attachRec, gauge: gauge, materialCards: materialCards, steppers: steppers, resultBar: resultBar, fmt: fmt, isEn: isEn };
})();
